const BLOCK_REFRESH_TIMEOUT = 50;
const MAX_BLOCK_REFRESH_TIMEOUT = 5000;
const MAX_FETCH_RETRIES = 2;
const REFRESH_TIMEOUT = 60000;

export {
  BLOCK_REFRESH_TIMEOUT,
  MAX_BLOCK_REFRESH_TIMEOUT,
  MAX_FETCH_RETRIES,
  REFRESH_TIMEOUT,
};

export default {
  BLOCK_REFRESH_TIMEOUT,
  MAX_BLOCK_REFRESH_TIMEOUT,
  MAX_FETCH_RETRIES,
  REFRESH_TIMEOUT,
};
